import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { createTitle } from "@/functions/createTitle";
import { branches_helper } from "@/helpers/branches_helper";

export default function ContactUsPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const title = "Contact Us";

  return {
    props: {
      meta: { title: createTitle(title) },
      content: [
        // {
        //   component: "BreadcrumbNavigation",
        //   props: {
        //     items: [{ label: "Contact us", href: getRoute("contact") }],
        //   },
        // },
        {
          component: "Header",
          props: {
            className: "bg-primary text-white",
            title: { path: "page.contact-us.component.Header.title", placeholder: title },
          },
        },
        {
          component: "BranchLocations",
          props: {
            branches: branches_helper.fetch(),
          },
        },
        {
          component: "FormEmbed",
          props: {
            embed: `<iframe sandbox="allow-forms allow-popups allow-scripts allow-top-navigation allow-same-origin" frameborder="0" ondisabledload="window.parent.scrollTo(0,0)" scrolling="no" src="https://forms.monday.com/forms/embed/b0a5ee29a30f57a4db09f457a85bddf9?r=use1" style="width:100%; height:1350px !important; border:none; min-height:1600px;"></iframe>`,
          },
        },
        // {
        //   component: "Form",
        //   props: {
        //     title: "Get in Touch",
        //     description: "",
        //     form_id: "1cbb7c62-7c6e-473f-835f-a56cbfff1916",
        //   },
        // },
      ],
    },
  };
}
